<template>
  <v-dialog persistent v-model="dialog" :width="isOnMobile ? '100%' : 600">
    <v-card class="box-container ma-0 pa-0" :height="'auto'" style="overflow: hidden;" width="100%" min-width="100%">
      <v-row class="row-header ma-0 pa-0" justify="center" align="center">
        <v-spacer></v-spacer>
        <span>{{ isInStorno ? `Сторно към бон № ${rcpNum}` : "Сторно бон" }}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" text fab small @click="cancelStorno">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider class="row-header ma-0 pa-0"></v-divider>
      <v-form class="row-header ma-0 pa-0" style="width: 100%;" ref="refStornoForm" v-on:submit.prevent lazy-validation>
        <v-row class="ma-4 pa-0">
          <v-select v-if="isInStorno || isInManualStorno" class="ma-0 pa-0" item-text="name" :items="optionsStornoReasons" v-model="stornoReason" label="Причина за сторно" @change="isInManualStorno?$refs['refRcpNum'].focus():''" hide-details autofocus></v-select>
        </v-row>
        <v-row class="ma-4 pa-0" v-if="!isInStorno" justify="center">
          <label ref="refRcpNum" style="width: 100%;">
            <v-text-field dense v-model.number="rcpNum" :autofocus="!isInStorno" :rules="validRcp_Num" @keydown.enter.stop="findReceiptForStorno()" label="Номер на бон или QR код"></v-text-field>
          </label>
          <v-btn v-if="isOnAndroid && !isInStorno && !isInManualStorno" class="ma-0 pa-0" @click="startScanner()">
            <v-icon>mdi-camera</v-icon>
          </v-btn>
        </v-row>
        <v-row class="ma-4 pa-0" v-if="isInManualStorno">
          <v-dialog ref="caldendarDialogRef" v-model="modalCalendar" :return-value.sync="rcpDate" persistent width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-on="on" maxlength="10" height="17" hide-details fluid label="Дата на издаване на бона" color="default" :value="getFullDate(rcpTime, rcpDate).toStringWithFormat('dd.MM.yyyy hh:mm:ss')"></v-text-field>
            </template>
            <v-date-picker full-width v-if="!calendarDateSet" firstDayOfWeek="1" type="date" locale="bg" v-model="rcpDate">
              <v-row class="ma-0 pa-0" justify="end">
                <v-btn color="warning" tile class="elevation-0 mr-1" @click="modalCalendar = false">Отказ</v-btn>
                <v-btn color="success" tile class="elevation-0 ml-1" @click="calendarDateSet = true">OK</v-btn>
              </v-row>
            </v-date-picker>
            <v-time-picker v-else v-model="rcpTime" full-width use-seconds format="24hr">
              <v-row class="pa-0 ma-0" justify="end">
                <v-btn color="warning" tile class="elevation-0 mr-1" @click="
                          () => {
                            modalCalendar = false;
                            calendarDateSet = false;
                          }
                        ">Отказ</v-btn>
                <v-btn color="success" tile class="elevation-0 ml-1" @click="
                          () => {
                            $refs.caldendarDialogRef.save(rcpDate);
                            modalCalendar = false;
                            calendarDateSet = false;
                          }
                        ">OK</v-btn>
              </v-row>
            </v-time-picker>
          </v-dialog>
        </v-row>
        <v-row v-if="isInManualStorno" class="ma-4 pa-0">
          <label ref="refFMNum" style="width: 100%;">
            <v-text-field v-model="fmNum" max-length dense :rules="validFM_Num" label="Номер на фискална памет"></v-text-field>
          </label>
        </v-row>
      </v-form>
      <v-row class="row-content ma-0 pa-0" justify="center" v-if="isInStorno">
        <v-simple-table class="ma-0 pa-0" dense :height="stornoRcpInfo.articles.length * (isOnMobile? 50:32) + 50" style="overflow-y: auto;">
          <template v-slot:default>
            <thead class="ma-0 pa-0">
              <tr>
                <th class="text-center">Избор</th>
                <th class="text-center">Артикул</th>
                <th v-if="!isOnMobile || currentResBP == `sm`" class="text-center">Дан. група</th>
                <th v-if="!isOnMobile || currentResBP == `sm`" class="text-center">Бр./Кол.</th>
                <th v-if="!isOnMobile || currentResBP == `sm`" class="text-center">Ед. цена</th>
                <th class="text-center">Обща сума</th>
              </tr>
            </thead>
            <tbody class="ma-0 pa-0">
              <!-- <tr v-for="plu in stornoRcpInfo.articles" :key="plu.Index" :class="plu.IsVoided?'strikeout':''"> -->
              <tr v-for="plu in stornoRcpInfo.articles" :key="plu.Index">
                <td>
                  <v-row justify="center" align="center">
                    <input :disabled="plu.IsVoided" type="checkbox" dense v-bind:id="plu.Index" v-bind:value="plu" v-model="articlesToStorno" />
                  </v-row>
                </td>
                <td :class="plu.IsVoided?'grey--text':''" class="text-start">{{ plu.Name }}</td>
                <td :class="plu.IsVoided?'grey--text':''" v-if="!isOnMobile || currentResBP == `sm`" class="text-center">{{ plu.VAT }}</td>
                <td :class="plu.IsVoided?'grey--text':''" v-if="!isOnMobile || currentResBP == `sm`" class="text-center">{{ plu.Qty }}</td>
                <td :class="plu.IsVoided?'grey--text':''" v-if="!isOnMobile || currentResBP == `sm`" class="text-end">{{ plu.Price }}</td>
                <td :class="plu.IsVoided?'grey--text':''" class="text-end">{{ plu.Price_Total }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
      <v-row v-if="isInStorno" class="row-header ma-0 pa-0">
        <v-col class="ma-0 pa-0" :cols="isOnPhone?12:8">
          <v-row class="ma-0 pa-0" justify="start">
            <input class="ma-2 pa-0" id="idCheckboxSelectAll" type="checkbox" dense v-model="selectedAll" @change="selectAllArticles" />
            <label class="ma-2 pa-0" for="idCheckboxSelectAll">{{ selectedAll? 'Размаракирай всички':'Маркирай всички'}}</label>
          </v-row>
        </v-col>
        <v-col class="ma-0 pa-0" :cols="isOnPhone?12:4">
          <v-row class="ma-0 pa-0" justify="end">
            <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="finishStorno">
              <v-icon color="#1685c9">mdi-file-check-outline</v-icon>
              <span>Сторнирай</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-else-if="isInManualStorno" class="row-header ma-2 pa-0" justify="space-between">
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="isInManualStorno = false">
          <v-icon color="#1685c9">mdi-arrow-left-bold</v-icon>
          <span>Назад</span>
        </v-btn>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="openManualStorno">
          <v-icon color="#1685c9">mdi-file-upload-outline</v-icon>
          <span>Отвори</span>
        </v-btn>
      </v-row>
      <v-row v-else class="ma-0 pa-2" justify="space-between">
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="ma-0 pa-2 elevation-0" @click="startManualStorno()">
          <v-icon color="#1685c9">mdi-pencil-box-outline</v-icon>
          <span>Ръчно</span>
        </v-btn>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="ma-0 pa-2 elevation-0" @click="findReceiptForStorno()">
          <v-icon color="#1685c9">mdi-file-find-outline</v-icon>
          <span>Намери</span>
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import Tremol from "../assets/fp/fp";
import Const from "../constants";
import KLENparser from "../assets/fp/KLENparser";

export default {
  props: {},
  data() {
    return {
      // error: "",
      isQRRegEx: new RegExp(/^\d{8}\*\d{6}\*\d{4}-\d{2}-\d{2}\*\d{2}:\d{2}:\d{2}\*\d+\.\d{2}$/),
      dialog: true,
      stornoReason: null,
      selectedAll: false,
      rcpNum: null,
      rcpDate: new Date().toStringWithFormat("yyyy-MM-dd"),
      rcpTime: "00:00:00",
      fmNum: "",
      isInStorno: false,
      isInManualStorno: false,
      stornoRcpInfo: {
        rcpType: "",
        dateAndTime: "",
        invoiceNum: Number(null),
        fmNum: Number(null),
        articles: []
      },
      articlesToStorno: [],

      optionsStornoReasons: [
        {
          name: "Операторска грешка",
          value: Tremol.Enums.OptionStornoReason.Operator_error
        },
        {
          name: "Връщане на стока / рекламация",
          value: Tremol.Enums.OptionStornoReason.Goods_Claim_or_Goods_return
        },
        {
          name: "Намаляване на данъчната основа",
          value: Tremol.Enums.OptionStornoReason.Tax_relief
        }
      ],

      modalCalendar: false,
      calendarDateSet: false,
      validRcp_Num: [
        v => !!v || "Задължително поле",
        v => {
          if ((!isNaN(parseInt(v)) && v >= 0 && v <= 999999) || (!!v && v.toString().split("*").length == 5 && parseInt(v.toString().split("*")[0]) && parseInt(v.toString().split("*")[1]))) return true;
          return "Невалиден номер на бон";
        }
      ],
      validFM_Num: [v => !!v || "Задължително поле", v => (v.length == 8 && v.indexOf("50") == 0 && !isNaN(Number(v))) || "Номерът на ФП трябва да започва с 50 и да е 8 цифри!"]
    };
  },
  computed: {
    currentResBP() {
      return this.$vuetify.breakpoint.name;
    }
  },
  methods: {
    startScanner() {
      this.fp.addMode(Const.Modes.QRScanner, () => {
        if (this.fp.lastQRCode) {
          this.rcpNum = this.fp.lastQRCode;
          this.fp.lastQRCode = "";
        }
      });
    },
    startManualStorno() {
      this.isInManualStorno = true;
      this.$nextTick(() => {
        if (this.$refs.refStornoForm) {
          try {
            this.$refs.refStornoForm.resetValidation();
          } catch {
            /**ignored */
          }
        }
      });
    },
    selectAllArticles() {
      this.articlesToStorno = [];
      if (this.selectedAll) {
        this.stornoRcpInfo.articles.forEach(a => {
          if (!a.IsVoided) this.articlesToStorno.push(a);
        });
      }
    },
    /** @returns {Date} */
    getFullDate(time, date) {
      let tArr = time.split(":");
      let dt = new Date(date);
      dt.setHours(Number(tArr[0]));
      dt.setMinutes(Number(tArr[1]));
      dt.setSeconds(Number(tArr[2]));
      return dt;
    },
    async rawRead() {
      let resArr = await this.fp.RawRead(0, "@");
      let lines = resArr.toUnicodeString().split("\n");
      let res = [];
      lines.forEach(l => {
        let i = l.substring(4, l.length - 2).win1251toUTF();
        if (i.length > 1) res.push(i);
      });
      return res;
    },
    async findReceiptForStorno() {
      if (this.$refs.refStornoForm.validate()) {
        try {
          // let qr = this.rcpNum.toString().split("*");
          // if (qr.length == 5 && parseInt(qr[0]) && parseInt(qr[1])) {
          //   this.rcpNum = parseInt(qr[1]);
          // }
          this.stornoRcpInfo.articles = [];
          let res_TXT = null;
          await this.fp.executeWithLoader(async () => {
            try {
              await this.fp.ReadEJByReceiptNumCustom(Tremol.Enums.OptionStorageReport.To_PC, Tremol.Enums.OptionCSVformat.No, "65", "64", this.rcpNum, this.rcpNum);
              res_TXT = (await this.rawRead()).join("\r\n");
            } catch (ex) {
              this.fp.handleException(ex);
            }
          }, "Търсене на бона в КЛЕН на ФУ...");
          if (res_TXT == null) {
            return;
          }
          if (res_TXT.length == 0) {
            this.fp.setErrorMessage("Бон с номер " + this.rcpNum + " не е фискален бон за продажба!");
            return;
          }
          var recArr = KLENparser.parse(res_TXT);
          if (recArr.length == 0) {
            this.fp.setErrorMessage("Бон с номер " + this.rcpNum + " не е фискален бон за продажба!");
            return;
          }
          var recO = recArr[0];
          this.rcpNum = Number(recO.rcpNum);

          if (recO.storno || recO.invoice) {
            this.fp.setErrorMessage("Невалиден номер на бон!");
            return;
          }

          this.stornoRcpInfo.dateAndTime = recO.rcpDateTime.parseDateWithFormat(Date.TremolFpFormat);
          this.stornoRcpInfo.fmNum = recO.rcpFMnum;

          var tmpA = [];
          tmpA.push(
            ...recO.articles
              .filter(a => !a.voidFlag)
              .map((a, index) => {
                return {
                  Index: index,
                  Name: a.name,
                  Price: a.price,
                  Qty: a.qty,
                  Price_Total: a.artTotalSum,
                  IsVoided: a.voidFlag,
                  VAT: a.taxgr
                };
              })
          );
          recO.articles
            .filter(a => a.voidFlag)
            .forEach(va => {
              var foundIdx = tmpA.findIndex(a => a.IsVoided == false && a.Name == va.name && a.Price == va.price && a.Qty == va.qty && a.Price_Total == va.artTotalSum && a.VAT == va.taxgr);
              if (foundIdx > -1) {
                tmpA[foundIdx].IsVoided = true;
              }
            });
          this.stornoRcpInfo.articles = tmpA;
          this.isInStorno = true;
        } catch (ex) {
          this.fp.setErrorMessage("Грешка при обработка на бон " + this.rcpNum + ". " + ex);
          this.isInManualStorno = true;
          // this.error = `Не съществува бон № ${this.rcpNum}`;
          this.$refs.refStornoForm.validate();
        }
      }
    },
    async openManualStorno() {
      if (this.$refs.refStornoForm.validate()) {
        try {
          await this.fp.OpenStornoReceipt(1, this.fp.operator1pass, this.uiSettings.receiptFormat, this.uiSettings.printVatInReceipt, Tremol.Enums.OptionStornoRcpPrintType.Step_by_step_printing, this.stornoReason, this.rcpNum, this.getFullDate(this.rcpTime, this.rcpDate), this.fmNum, null);
          this.cancelStorno();
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }
    },
    async finishStorno() {
      await this.fp.executeWithLoader(async () => {
        try {
          if (!this.stornoReason) throw new Error("Моля изберете причина за сторно!");
          if (this.articlesToStorno.length == 0) throw new Error("Моля изберете артикули, които да сторнирате!");
          await this.fp.OpenStornoReceipt(1, this.fp.operator1pass, this.uiSettings.ReceiptFormat, this.uiSettings.printVatInReceipt, Tremol.Enums.OptionStornoRcpPrintType.Postponed_Printing, this.stornoReason, this.rcpNum, this.stornoRcpInfo.dateAndTime.toTremolFpString(), this.stornoRcpInfo.fmNum, null);
          await this.articlesToStorno.asyncForEach(async plu => {
            await this.fp.SellPLUwithSpecifiedVAT(plu.Name, plu.VAT, plu.Price, plu.Qty);
          });
          await this.fp.CashPayCloseReceipt();
          this.cancelStorno();
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }, "Отпечатване на сторно бон...");
    },
    cancelStorno() {
      this.articlesToStorno = [];
      this.stornoRcpInfo.articles = [];
      this.isInManualStorno = false;
      this.isInStorno = false;
      this.fp.exitMode(Const.Modes.Storno);
    }
  },
  watch: {
    rcpNum(val) {
      if (val.toString().match(this.isQRRegEx)) {
        this.$nextTick(() => {
          let qrArr = val.split("*");
          this.rcpNum = Number(qrArr[1]);
          this.fmNum = qrArr[0];
          this.stornoRcpInfo.fmNum = qrArr[0];
          this.rcpDate = qrArr[2];
          this.rcpTime = qrArr[3];
          this.$nextTick(() => {
            this.findReceiptForStorno();
          });
        });
      }
    }
  },
  mounted() {}
};
</script>